import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { saveAs } from 'file-saver';
import { FileText } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Small reusable "day clock report PDF" button (admin-only endpoint).
export default function DayPdfButton({ employeeId, employeeName, date, className = '' }) {
  const [busy, setBusy] = useState(false);
  if (!employeeId || !date) return null;
  const run = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      const r = await axios.get(`${API}/admin/clock/day-report-pdf`, {
        params: { employee_id: employeeId, date },
        responseType: 'blob',
      });
      const safe = (employeeName || 'employee').replace(/[^a-zA-Z0-9 _-]/g, '').replace(/\s+/g, '_');
      saveAs(new Blob([r.data], { type: 'application/pdf' }), `${safe}_${date}_clock_report.pdf`);
      toast.success('Day PDF downloaded');
    } catch {
      toast.error('Failed to export day PDF');
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      type="button"
      onClick={run}
      className={`inline-flex items-center gap-1 text-[10px] uppercase text-red-400 hover:text-red-300 border border-red-500/40 rounded-sm px-1.5 py-0.5 ${className}`}
      data-testid={`day-pdf-${employeeId}-${date}`}
      title="Download day clock report PDF (photo + GPS)"
    >
      <FileText className="w-3 h-3" />
      {busy ? '…' : 'PDF'}
    </button>
  );
}
